const map = {
	"./box": 4666,
	"./box/": 4666,
	"./box/index": 4666,
	"./box/index.tsx": 4666,
	"./box_children": 5616,
	"./box_children/": 5616,
	"./box_children/index": 5616,
	"./box_children/index.tsx": 5616,
	"./box_children/styles.scss": 5032,
	"./column": 381,
	"./column/": 381,
	"./column/index": 381,
	"./column/index.tsx": 381,
	"./column/styles.scss": 1525,
	"./columns": 912,
	"./columns/": 912,
	"./columns/index": 912,
	"./columns/index.tsx": 912,
	"./embedded": 741,
	"./embedded/": 741,
	"./embedded/index": 741,
	"./embedded/index.scss": 9889,
	"./embedded/index.tsx": 741,
	"./heading": 7263,
	"./heading/": 7263,
	"./heading/index": 7263,
	"./heading/index.tsx": 7263,
	"./image": 9382,
	"./image/": 9382,
	"./image/index": 9382,
	"./image/index.tsx": 9382,
	"./image/styles.scss": 2368,
	"./paragraph": 2951,
	"./paragraph/": 2951,
	"./paragraph/index": 2951,
	"./paragraph/index.tsx": 2951,
	"./svg": 1927,
	"./svg/": 1927,
	"./svg/index": 1927,
	"./svg/index.tsx": 1927,
	"./svg/styles.scss": 1821,
	"./types": 5425,
	"./types.ts": 5425
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3140;